import { render } from "./BonsManager.vue?vue&type=template&id=3b202dd7&scoped=true"
import script from "./BonsManager.vue?vue&type=script&lang=js"
export * from "./BonsManager.vue?vue&type=script&lang=js"

import "./BonsManager.vue?vue&type=style&index=0&id=3b202dd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b202dd7"]])

export default __exports__